// Store configuration of Rhino as a whole system only, don't put here configurations of
// Rhino's subsystems, make them local to fit "low coupling, high cohesion" principle
type RhinoConfig = {
  isDebug: boolean;
};

let rhinoConfig = {
  isDebug: false,
};

export function updateRhinoConfig(updater: (state: RhinoConfig) => RhinoConfig) {
  rhinoConfig = updater(rhinoConfig);
}

export function getRhinoConfig() {
  return rhinoConfig;
}
